import { useUserStore } from '@/shared/store/useUserStore';

export function profileStoreUser() {
  const store = useUserStore();
  return store.getUserInfo;
}
